import angular from 'angular';

module.exports = angular.module('common.filters.street', [])
.filter('street', function() {
  return function(listing) {
    if (!listing) return;

    let street = listing.street1;
    if (listing.unit || listing.unit === '0') {
      street += ' #' + listing.unit;
    }

    return street;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/street.js
 **/